module.exports = {
    PLAYER: 'giocatore',
    HOST: 'conduttore',
    EDITOR: 'redattore',
    DEV: 'DEV',
    SYSTEM: 'sistema'
}


// WEBPACK FOOTER //
// ./src/models/Roles.js